import { type IApiResponse, type IRolesStates } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';
import { type ICreateRoleProps, type IUpdateRoleProps } from '@/store/actions/core/role';

import { coreApiSlice } from '../apiSlice';

export const roleApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getRole: builder.query<IRolesStates, IGetQuery>({
			query: ({ paged, query }) => ({
				method: 'GET',
				url: `/Role${getCommandQuery(paged, ...(query || []))}`,
			}),
		}),
		createRole: builder.mutation<IApiResponse, ICreateRoleProps>({
			query: (body) => ({
				method: 'POST',
				url: '/Role',
				body,
			}),
		}),
		updateRole: builder.mutation<IApiResponse, IUpdateRoleProps>({
			query: (body) => ({
				method: 'PUT',
				url: '/Role/update',
				body,
			}),
		}),
		deleteRole: builder.mutation<IApiResponse, { roleName: string }>({
			query: ({ roleName }) => ({
				method: 'DELETE',
				url: `/Role?roleName=${roleName}`,
			}),
		}),
		assignMultipleActionsToRole: builder.mutation<IApiResponse, { actionIds: number[]; roleId: number }>({
			query: (body) => ({
				method: 'POST',
				url: '/Role/assign-multiple-actions',
				body,
			}),
		}),
		unassignMultipleActionsToRole: builder.mutation<IApiResponse, { actionIds: number[]; roleId: number }>({
			query: (body) => ({
				method: 'POST',
				url: '/Role/unassign-multiple-actions',
				body,
			}),
		}),
	}),
});

export const {
	useGetRoleQuery,
	useLazyGetRoleQuery,
	useDeleteRoleMutation,
	useUnassignMultipleActionsToRoleMutation,
	useAssignMultipleActionsToRoleMutation,
	useUpdateRoleMutation,
	useCreateRoleMutation,
} = roleApiSlice;
